/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanySelfPublishTagRequest } from './company-self-publish-tag-request';

export interface DeckCompanyDetailRequest {
  name: string;
  self_publish_tags: Array<CompanySelfPublishTagRequest>;
  address_id: string;
  organization_number: string;
  total_shares?: number;
  capital?: number | null;
}
